<template>
  <div>
    <a-drawer
      title="普通合同修改内容"
      placement="right"
      :closable="true"
      :visible="visible"
      :mask="false"
      width="500"
      @close="closeDrawer"
    >
      <div>
        <span v-for="(record, index) in contractRecordList" :key="index">
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['trade_contract_type']">类型：{{ dictionaries.trade_contract_type[parseContractRecord(record['modify_record'])['trade_contract_type']['before']] }} -> {{ dictionaries.trade_contract_type[parseContractRecord(record['modify_record'])['trade_contract_type']['after']] }}</span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['client']">客户：{{ parseContractRecord(record['modify_record'])['client']['before'] }} -> {{ parseContractRecord(record['modify_record'])['client']['after'] }}</span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['name']">名称：{{ parseContractRecord(record['modify_record'])['name']['before'] }} -> {{ parseContractRecord(record['modify_record'])['name']['after'] }}</span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['fee_standards']">收费标准：{{ parseContractRecord(record['modify_record'])['fee_standards']['before'] }} -> {{ parseContractRecord(record['modify_record'])['fee_standards']['after'] }}</span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['other_fee']">其他费用：{{ parseContractRecord(record['modify_record'])['other_fee']['before'] }} -> {{ parseContractRecord(record['modify_record'])['other_fee']['after'] }}</span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['total_fee']">收费总费用：{{ parseContractRecord(record['modify_record'])['total_fee']['before'] }} -> {{ parseContractRecord(record['modify_record'])['total_fee']['after'] }}</span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['charging_period']"> 收费期限：
            {{ parseContractRecord(record['modify_record'])['charging_period']['before'] }} -> {{ parseContractRecord(record['modify_record'])['charging_period']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['purchase_settlement_amount']">采购合同金额：{{ parseContractRecord(record['modify_record'])['purchase_settlement_amount']['before'] }} -> {{ parseContractRecord(record['modify_record'])['purchase_settlement_amount']['after'] }}</span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['vat']">增值税率（%）：
            {{ parseContractRecord(record['modify_record'])['vat']['before'] }} -> {{ parseContractRecord(record['modify_record'])['vat']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['guarantee_method']">担保方式：
            {{ parseContractRecord(record['modify_record'])['guarantee_method']['before'] }} -> {{ parseContractRecord(record['modify_record'])['guarantee_method']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['storage_location']">存放地：
            {{ parseContractRecord(record['modify_record'])['storage_location']['before'] }} -> {{ parseContractRecord(record['modify_record'])['storage_location']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['collateral']">抵押物：
            {{ parseContractRecord(record['modify_record'])['collateral']['before'] }} -> {{ parseContractRecord(record['modify_record'])['collateral']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['pledged_goods']">质押物：
            {{ parseContractRecord(record['modify_record'])['pledged_goods']['before'] }} -> {{ parseContractRecord(record['modify_record'])['pledged_goods']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['collateral_pledged_goods_value']">抵/质押货物价值：
            {{ parseContractRecord(record['modify_record'])['collateral_pledged_goods_value']['before'] }} -> {{ parseContractRecord(record['modify_record'])['collateral_pledged_goods_value']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['registration_method']">登记方式：
            {{ parseContractRecord(record['modify_record'])['registration_method']['before'] }} -> {{ parseContractRecord(record['modify_record'])['registration_method']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['guarantee_period']">担保期限：
            {{ parseContractRecord(record['modify_record'])['guarantee_period']['before'] === '1970-01-01' ? '无' : parseContractRecord(record['modify_record'])['guarantee_period']['before'] }} -> {{ parseContractRecord(record['modify_record'])['guarantee_period']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['business_type']">业务类型：
            {{ dictionaries.trade_contract_business_type[parseContractRecord(record['modify_record'])['business_type']['before']] }} -> {{ dictionaries.trade_contract_business_type[parseContractRecord(record['modify_record'])['business_type']['after']] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['payment_method']">支付方式：
            {{ dictionaries.trade_payment_method[parseContractRecord(record['modify_record'])['payment_method']['before']] }} -> {{ dictionaries.trade_payment_method[parseContractRecord(record['modify_record'])['payment_method']['after']] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['fee_standards_desc']">收费标准描述：
            {{ parseContractRecord(record['modify_record'])['fee_standards_desc']['before'] }} -> {{ parseContractRecord(record['modify_record'])['fee_standards_desc']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['other_fee_desc']">其他费用描述：
            {{ parseContractRecord(record['modify_record'])['other_fee_desc']['before'] }} -> {{ parseContractRecord(record['modify_record'])['other_fee_desc']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['pricing_currency']">计价币种：
            {{ dictionaries.currency[parseContractRecord(record['modify_record'])['pricing_currency']['before']] }} -> {{ dictionaries.currency[parseContractRecord(record['modify_record'])['pricing_currency']['after']] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['contract_name']">合同名称：
            {{ parseContractRecord(record['modify_record'])['contract_name']['before'] }} -> {{ parseContractRecord(record['modify_record'])['contract_name']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['storage_location']">储存地：
            {{ parseContractRecord(record['modify_record'])['storage_location']['before'] }} -> {{ parseContractRecord(record['modify_record'])['storage_location']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['warehouse_manager']">库管方：
            {{ parseContractRecord(record['modify_record'])['warehouse_manager']['before'] }} -> {{ parseContractRecord(record['modify_record'])['warehouse_manager']['after'] }}
          </span>
          <span class="desc" v-if="date_change(parseContractRecord(record['modify_record']))">仓储租赁期限：
            {{ parseContractRecord(record['modify_record'])['lease_start_date']['before'] }} ~ {{ parseContractRecord(record['modify_record'])['lease_end_date']['before'] }} -> {{ parseContractRecord(record['modify_record'])['lease_start_date']['after'] }} ~ {{ parseContractRecord(record['modify_record'])['lease_end_date']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['billing_method']">计费方式：
            {{ parseContractRecord(record['modify_record'])['billing_method']['before'] }} -> {{ parseContractRecord(record['modify_record'])['billing_method']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['payment_cycle']">支付周期：
            {{ parseContractRecord(record['modify_record'])['payment_cycle']['before'] }} -> {{ parseContractRecord(record['modify_record'])['payment_cycle']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['insurance_company']">保险公司名称：
            {{ parseContractRecord(record['modify_record'])['insurance_company']['before'] }} -> {{ parseContractRecord(record['modify_record'])['insurance_company']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['shipping_company']">运输公司名称：
            {{ parseContractRecord(record['modify_record'])['shipping_company']['before'] }} -> {{ parseContractRecord(record['modify_record'])['shipping_company']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['inspection_company']">商检公司名称：
            {{ parseContractRecord(record['modify_record'])['inspection_company']['before'] }} -> {{ parseContractRecord(record['modify_record'])['inspection_company']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['freight_forwarder_company']">货代公司名称：
            {{ parseContractRecord(record['modify_record'])['freight_forwarder_company']['before'] }} -> {{ parseContractRecord(record['modify_record'])['freight_forwarder_company']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['loading_supervision_company']">监装公司名称：
            {{ parseContractRecord(record['modify_record'])['loading_supervision_company']['before'] }} -> {{ parseContractRecord(record['modify_record'])['loading_supervision_company']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['supervision_company']">监管公司名称：
            {{ parseContractRecord(record['modify_record'])['supervision_company']['before'] }} -> {{ parseContractRecord(record['modify_record'])['supervision_company']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['insurance_type']">保险险别：
            {{ parseContractRecord(record['modify_record'])['insurance_type']['before'] }} -> {{ parseContractRecord(record['modify_record'])['insurance_type']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['free_limit']">免费额规定：
            {{ parseContractRecord(record['modify_record'])['free_limit']['before'] }} -> {{ parseContractRecord(record['modify_record'])['free_limit']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['demurrage_terms']">滞期费规定：
            {{ parseContractRecord(record['modify_record'])['demurrage_terms']['before'] }} -> {{ parseContractRecord(record['modify_record'])['demurrage_terms']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['despatch_terms']">速遣费规定：
            {{ parseContractRecord(record['modify_record'])['despatch_terms']['before'] }} -> {{ parseContractRecord(record['modify_record'])['despatch_terms']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['free_demurrage_days']">免堆期：
            {{ parseContractRecord(record['modify_record'])['free_demurrage_days']['before'] }} -> {{ parseContractRecord(record['modify_record'])['free_demurrage_days']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['inspection_items']">检验事项：
            {{ parseContractRecord(record['modify_record'])['inspection_items']['before'] }} -> {{ parseContractRecord(record['modify_record'])['inspection_items']['after'] }}
          </span>
          <span class="desc" v-if="parseContractRecord(record['modify_record'])['service_content']">服务内容：
            {{ parseContractRecord(record['modify_record'])['service_content']['before'] }} -> {{ parseContractRecord(record['modify_record'])['service_content']['after'] }}
          </span>
        </span>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'

export default {
  name: 'ContractRecord',
  props: {
    contractRecordList: {
      type: Array,
      default: () => {
        return []
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    paymentMethodTitle () {
      return (payment_method) => {
        return payment_method <= 5 ? '预付款' + this.dictionaries.trade_pre_payment_method[payment_method] : '尾款' + this.dictionaries.trade_balance_payment_method[payment_method]
      }
    },
    parseContractRecord () {
      return (record) => {
        return JSON.parse(record)
      }
    },
    date_change () {
      return (record) => {
        return record['lease_start_date'] && record['lease_end_date']
      }
    }
  },
  data () {
    return {
      dictionaries: Dictionaries
    }
  },
  methods: {
    closeDrawer () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: block;
}
</style>
